export enum TravelInsuranceTab {
    Plans="Plans",
    Agencies="Agencies",
    Benefits="Benefits",
    Destinations = "Destinations",
    ExchangeRates = "Exchange Rates"
}

